module.exports = __webpack_public_path__ + "static/media/icon-vertical-horizontal.fb5f0da9.svg";